import React from 'react';
import { SherbetLogo } from "../../../../styles/images/svg/SherbetLogo"
import OtpVerification from './forms/OtpVerification';
import { AuthWrapper } from '../../../_uiComponents/common/AuthWrapper';

export function OtpVerifyWrapper(props) {

    return (
        <>
         <AuthWrapper heading="OTP Verification">
            <OtpVerification />
         </AuthWrapper>
        </>
    )
}

